'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
import * as FieldTypes from '../constants/dataSyncs/FieldType';
export default class FieldMapping extends Immutable.Record({
  fieldType: null,
  appField: null,
  hubSpotField: null
}) {
  constructor(values) {
    super(Immutable.fromJS(cleanObject(values)));
  }
  isValid() {
    return this.get('appField') && (this.get('fieldType') === FieldTypes.CUSTOM || this.get('hubSpotField'));
  }
  isBlank() {
    return !this.get('appField') && !this.get('hubSpotField');
  }
}